import React, { useState } from 'react';
import { useUsersData } from '../../../../../../../Hooks/TT_ELD/Users';
import { useParams } from 'react-router-dom';
import { Button, TableProps } from 'antd';
import SearchInput from '../../../../../../../Utils/SearchInput';
import UsersTable from '../../../Users/UsersTable';
import useRouteQuery from '../../../../../../../Utils/useRouterQuery';
import { TableParams } from '../../../../../../../Utils/TableTypes';

const TabDrivers = () => {
  const { id } = useParams();
  const [userName, setUserName] = useState<undefined | string>('');
  const [status, setStatus] = useState<string | null>(null);
  const [driverId, setDriverId] = useRouteQuery('', 'driverId', (v) => String(v));
  const [driverEmail, setDriverEmail] = useRouteQuery('', 'driverEmail', (v) => String(v));
  const [uid, setUid] = useRouteQuery('', 'uid', (v) => String(v));
  const [companyUID, setCompanyUID] = useRouteQuery('', 'companyUID', (v) => String(v));
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const companyId = id;

  const { data, refetch, isLoading, isFetching } = useUsersData(
    companyId,
    'driver',
    status!,
    driverId,
    driverEmail,
    userName,
    '',
    uid,
    companyUID,
    tableParams,
  );

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      driverId: setDriverId,
      driverEmail: setDriverEmail,
      uid: setUid,
      companyUID: setCompanyUID,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
    }
  };

  const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter) => {
    if (!Array.isArray(sorter)) {
      const mapOrderToString = (order: 'ascend' | 'descend' | null | undefined): string | null => {
        if (order === 'ascend') return 'true';
        if (order === 'descend') return 'false';
        return null;
      };

      setStatus(mapOrderToString(sorter?.order));
    }

    setTableParams({
      pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };

  return (
    <div>
      <SearchInput
        value={driverId}
        placeholder="Driver name"
        onDebounceChange={(event: string) => handleChange(event, 'driverId')}
      />
      <SearchInput
        value={driverEmail}
        placeholder="Driver email"
        onDebounceChange={(event: string) => handleChange(event, 'driverEmail')}
      />
      <SearchInput
        value={uid}
        placeholder="Search by UID"
        onDebounceChange={(event: string) => handleChange(event, 'uid')}
      />
      <SearchInput
        value={companyUID}
        placeholder="Search by Company UID"
        onDebounceChange={(event: string) => handleChange(event, 'companyUID')}
      />
      <Button
        style={{ float: 'right', marginLeft: '15px' }}
        size={'large'}
        onClick={() => refetch()}
      >
        Refresh
      </Button>
      <UsersTable
        data={data?.data}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refetch}
        handleTableChange={handleTableChange}
        tableParams={tableParams}
        pagination={{ total: data?.count, showSizeChanger: false }}
      />
    </div>
  );
};

export default TabDrivers;
